module.exports = __webpack_public_path__ + "img/Covid-19.940d41d4.png";